import useEventStream from "./useEventStream";

export interface ProgressEventSubscription {
  code: string;
  handle: (data: unknown) => void;
}

/** One event of an operation: its payload goes to `handle` only once `isPayload` accepts it. */
export function progressEvent<T>(
  code: string,
  isPayload: (data: unknown) => data is T,
  handle: (data: T) => void,
): ProgressEventSubscription {
  return {
    code,
    handle: (data) => {
      if (isPayload(data)) handle(data);
    },
  };
}

/**
 * Subscribes to a long-running operation's events on the shared SSE stream. `close` unsubscribes them
 * and releases this caller's share of the stream.
 */
export function useProgressEvents(events: ProgressEventSubscription[]) {
  const stream = useEventStream();
  const unsubscribes = events.map(({ code, handle }) => stream.on(code, handle));

  function close() {
    for (const unsubscribe of unsubscribes) unsubscribe();
    stream.close();
  }

  return { close };
}
